import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CollapsibleGroup, Collapsible, Icon } from '@fiverr-private/fit';
import { l_chevron_right } from '@fiverr-private/fit/icons';
import { I18n } from '@fiverr-private/fiverr_context';
import SafePureComponent from '../shared/SafePureComponent';
import { validateFaq } from '../../utils/mainComponentsValidator';
import { getCurrentContent } from '../../utils/ugc/getCurrentContent';
import { isTranslated } from '../../utils/ugc/isTranslated';
import TranslatedBadge from '../shared/TranslatedBadge';
import QuestionOrAnswer from './QuestionOrAnswer';

import './style.scss';

const Faq = ({ faq, showTranslatedBadge = false }) => {

    const [collapsed, setCollapsed] = useState(true);

    if (!validateFaq({ faq })) {
        return null;
    }

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    const {
        questionsAndAnswers
    } = faq;

    return (
        <div className={classNames('faq-collapsable', { 'is-collapsed': collapsed })}>
            <h2 className="section-title" onClick={toggleCollapsed}>
                <Icon className="faq-collapser">{l_chevron_right}</Icon>
                <I18n k={'gig_page_perseus.faq.title'}/>
            </h2>
            {showTranslatedBadge && <TranslatedBadge/>}
            <CollapsibleGroup>
                {questionsAndAnswers.map(({ question, answer }, index) => question && answer && (
                    <Collapsible title={<QuestionOrAnswer value={question} type={'question'}/>} key={index}>
                        <QuestionOrAnswer value={answer} type={'answer'}/>
                    </Collapsible>
                ))}
            </CollapsibleGroup>
        </div>
    );
};

Faq.propTypes = {
    faq: PropTypes.shape({
        questionsAndAnswers: PropTypes.arrayOf(
            PropTypes.shape({
                question: PropTypes.string,
                answer: PropTypes.string
            })
        )
    }),
    showTranslatedBadge: PropTypes.bool
};

const mapStateToProps = ({ ugc }) => {
    const { faq } = getCurrentContent({ ugc });

    return {
        faq,
        showTranslatedBadge: isTranslated(ugc)
    };
};

const ConnectedFaq = connect(mapStateToProps)(Faq);

export { Faq, ConnectedFaq };
export default SafePureComponent(ConnectedFaq);
